import {
  Accordion,
  Button,
  Drawer,
  TextInput,
  Select as FBSelect,
} from "flowbite-react";
import MultiRangeSlider, { ChangeResult } from "multi-range-slider-react";
import { useEffect, useMemo, useState } from "react";
import Loader from "../Common/Loader";
import blankImage from "../../Assets/NoPhoto.jpg";
import { Link } from "react-router-dom";
import { FaFilter } from "react-icons/fa6";
import SearchApi from "../../Api/SearchApi";
import { useAppSelector } from "../../Reducers/store";
import Select from "react-select";
import { SearchRequest } from "../../Models/SearchRequest";
import { SearchResult } from "../../Models/SearchResult";
import { SelectOption } from "../../Models/SelectOption";
import { formatNumbers } from "../../Utils";
import InfiniteScroll from "react-infinite-scroll-component";
//import PBLogo from '../../Assets/PriceBros-Logo.png';
import OrderApi from "../../Api/OrderApi";
import { OrderItem } from "../../Models/OrderItem";
import { Order } from "../../Models/Order";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import EmailModal from "../Forms/WarehouseAvailability";
import { Equipment } from "../../Models/Equipment";
import { Manufacturer } from "../../Models/Manufacturer";
import SearchListTable from "./SearchListTable";

export default function SearchPageParts() {
  const location = useLocation();
  const { userModel } = useAppSelector((state) => state.user);
  const { manufacturers, categories, subCategories, equipmentSearchData } =
    useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => setIsOpen(false);
  const [searchData, setSearchData] = useState<SearchResult[]>([]);
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem("searchTextState") ?? "",
    searchPartsText: localStorage.getItem("searchPartsTextState") ?? "",
    manufacturers: localStorage.getItem("manufacturersState")
      ? (
          JSON.parse(
            localStorage.getItem("manufacturersState")!
          ) as SelectOption[]
        ).map((a) => a.label!.trim())
      : null,
    categories: localStorage.getItem("categoriesState")
      ? (
          JSON.parse(localStorage.getItem("categoriesState")!) as SelectOption[]
        ).map((a) => a.label!.trim())
      : null,
    subCategories: localStorage.getItem("subCategoriesState")
      ? (
          JSON.parse(
            localStorage.getItem("subCategoriesState")!
          ) as SelectOption[]
        ).map((a) => a.label!.trim())
      : null,
    minPrice: localStorage.getItem("minPriceState")
      ? Math.ceil(Number(localStorage.getItem("minPriceState")))
      : equipmentSearchData?.minPrice
      ? Math.ceil(equipmentSearchData?.minPrice)
      : 0,
    maxPrice: localStorage.getItem("maxPriceState")
      ? Math.ceil(Number(localStorage.getItem("maxPriceState")))
      : equipmentSearchData?.maxPrice
      ? Math.ceil(equipmentSearchData?.maxPrice)
      : 1000,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 2,
  });
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState<Equipment>();
  const handleOpenEmailModal = (search: SearchResult) => {
    const man: Manufacturer = {
      name: search.manufacturerName,
      id: search.manufacturerId,
      address: null,
      city: null,
      stateId: null,
      zip: null,
      phone: null,
      email: null,
      description: null,
      website: null,
      rimssId: null,
      rimssOemvendorNumber: null,
      rimssPricebookId: null,
      active: null,
      parentManufacturerId: null,
      primaryImageURL: undefined,
      files: null,
      state: null,
    };
    const eq: Equipment = {
      id: search.equipmentId,
      number: search.equipmentName,
      manufacturer: man,
      manufacturerId: null,
      rimssId: null,
      price: null,
      cost: null,
      productId: null,
      productSource: null,
      locationId: null,
      oemvendor: null,
      oemdivision: null,
      priceBook: null,
      description: null,
      fullDescription: null,
      upc: null,
      sku: null,
      primaryBin: null,
      quantityOnHand: null,
      quantityCommitted: null,
      quantityOnOrder: null,
      aFS: null,
      quantityCommittedOnOrder: null,
      averageCost: null,
      manufacturerList: null,
      replacementCost: null,
      productClass: null,
      productCategory: null,
      productGroup: null,
      packageMultiple: null,
      height: null,
      width: null,
      depth: null,
      weight: null,
      associationType: null,
      tradePrice: null,
      listPrice: null,
      special1Price: null,
      special2Price: null,
      special3Price: null,
      inactive: null,
      pricingUoM: null,
      primaryImageURL: undefined,
      categoriesString: null,
      equipmentFeatures: null,
      equipmentSubCategories: null,
      files: null,
      equipmentVideos: null,
    };
    setSelectedEquipment(eq);
    setShowEmailModal(true);
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      searchPartsText: localStorage.getItem("searchPartsTextState") ?? "",
      skip: 0,
      reset: true,
    }));
    getSearchResults();
  }, []);

  const [selectedManufacturerOptions, setSelectedManufacturerOptions] =
    useState<SelectOption[] | null>(
      localStorage.getItem("manufacturersState")
        ? (JSON.parse(
            localStorage.getItem("manufacturersState")!
          ) as SelectOption[])
        : null
    );

  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState<
    SelectOption[] | null
  >(
    localStorage.getItem("categoriesState")
      ? (JSON.parse(localStorage.getItem("categoriesState")!) as SelectOption[])
      : null
  );

  const [selectedSubCategoryOptions, setSelectedSubCategoryOptions] = useState<
    SelectOption[] | null
  >(
    localStorage.getItem("subCategoriesState")
      ? (JSON.parse(
          localStorage.getItem("subCategoriesState")!
        ) as SelectOption[])
      : null
  );

  const manufacturerList = useMemo(() => {
    const list = manufacturers
      .filter((item) => item.rimssOemvendorNumber?.startsWith("2"))
      .map((t) => ({
        label: t.name,
        value: t.id!,
      })) as SelectOption[];

    return [...list];
  }, [manufacturers]);

  const categoryList = useMemo(() => {
    const list = categories.map((t) => ({
      label: t.name,
      value: t.number!,
    })) as SelectOption[];
    return [...list];
  }, [categories]);

  const subCategoryList = useMemo(() => {
    const unique = subCategories.filter((value, index, self) => {
      return self.findIndex((v) => v.name === value.name) === index;
    });
    const list = unique.map((t) => ({
      label: t.name,
      value: t.number!,
    })) as SelectOption[];
    return [...list];
  }, [subCategories]);

  const getSearchResults = async () => {
    setIsLoading(true);
    if (selectedManufacturerOptions) {
      formData.manufacturers = selectedManufacturerOptions.map(function (item) {
        return item.label!.trim();
      });
      localStorage.setItem(
        "manufacturersState",
        JSON.stringify(selectedManufacturerOptions)
      );
    } else {
      formData.manufacturers = null;
    }
    if (selectedCategoryOptions) {
      formData.categories = selectedCategoryOptions.map(function (item) {
        return item.label!.trim();
      });
      localStorage.setItem(
        "categoriesState",
        JSON.stringify(selectedCategoryOptions)
      );
    } else {
      formData.categories = null;
    }
    if (selectedSubCategoryOptions) {
      formData.subCategories = selectedSubCategoryOptions.map(function (item) {
        return item.label!.trim();
      });
      localStorage.setItem(
        "subCategoriesState",
        JSON.stringify(selectedSubCategoryOptions)
      );
    } else {
      formData.subCategories = null;
    }
    localStorage.setItem("searchPartsTextState", formData.searchPartsText!);
    // formData.searchText = localStorage.getItem('searchPartsTextState') ?? '';
    SearchApi.search(formData)
      .then((res) => {
        if (res.data.length > 0 || formData.reset) {
          if (formData.reset) {
            setSearchData(res.data);
          } else {
            setSearchData(searchData.concat(res.data));
          }
          setFormData((prevData) => ({
            ...prevData,
            reset: false,
          }));
        }
        // setSearchData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   if (searchData.length === 0) {
  //     getSearchResults();
  //   }
  // }, [searchData]);

  useEffect(() => {
    formData.searchPartsText = localStorage.getItem("searchPartsTextState");
    formData.skip = 0;
    formData.reset = true;
    if ((formData.searchPartsText ?? "").length > 0) getSearchResults();
  }, [localStorage.getItem("searchPartsTextState")]);

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      formData.skip = 0;
      formData.reset = true;
      getSearchResults();
      handleClose();
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleClearFiltersClick = () => {
    localStorage.setItem("manufacturersState", "");
    localStorage.setItem("categoriesState", "");
    localStorage.setItem("subCategoriesState", "");
    localStorage.setItem("searchPartsTextState", "");
    localStorage.setItem("minPriceState", "");
    localStorage.setItem("maxPriceState", "");
    setFormData((prevData) => ({
      ...prevData,
      searchText: "",
      searchPartsText: "",
      manufacturers: null,
      categories: null,
      subCategories: null,
      minPrice: equipmentSearchData?.minPrice
        ? Math.ceil(equipmentSearchData?.minPrice)
        : 0,
      maxPrice: equipmentSearchData?.maxPrice
        ? Math.ceil(equipmentSearchData?.maxPrice)
        : 0,
      equipmentType: 2,
    }));
    setSelectedManufacturerOptions(null);
    setSelectedCategoryOptions(null);
    setSelectedSubCategoryOptions(null);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedFormData = { ...prevData, [name]: Number(value) };

      return updatedFormData;
    });
    setTimeout(() => {
      getSearchResults();
    }, 100); // Small delay ensures state is updated first
  };

  const handleAddItemClick = async (equipment: SearchResult) => {
    if (userModel) {
      let openOrderId =
        localStorage.getItem("openOrderId") &&
        Number(localStorage.getItem("openOrderId")) >= 0
          ? Number(localStorage.getItem("openOrderId"))
          : 0;
      if (openOrderId === 0) {
        await OrderApi.checkUserOpenOrder(userModel.id)
          .then((res) => {
            if (res.data) {
              openOrderId = res.data.id;
              localStorage.setItem("openOrderId", openOrderId.toString());
            } else {
              const newOrder: Order = {
                id: 0,
                businessName: null,
                contactName: null,
                contactPhone: null,
                contactEmail: null,
                notes: null,
                dateCreated: null,
                orderStatusId: 1,
                userId: userModel.id,
                billingAddressId: null,
                shippingAddressId: null,
                dateSubmitted: null,
                ponumber: null,
                clientId: userModel.clientId,
                shippingMethodId: 15,

                client: null,
                orderItems: [],
                billingAddress: null,
                shippingAddress: null,
                user: null,
              };
              OrderApi.addUpdateOrder(newOrder)
                .then((res) => {
                  if (res.data.success) {
                    openOrderId = Number(res.data.affectedEntityIdentifier);
                    localStorage.setItem("openOrderId", openOrderId.toString());
                  }
                })
                .catch((err) => {
                  setIsLoading(false);
                });
            }
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
      const newOrderItem: OrderItem = {
        id: 0,
        orderId: openOrderId,
        equipmentId: equipment.equipmentId,
        quantity: 1,
        equipment: null,
      };
      await OrderApi.addUpdateOrderItem(newOrderItem)
        .then((res) => {
          if (res.data.success) {
            toast.success("Item added to cart");
          }
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
      await OrderApi.getOrderItemsCount(openOrderId)
        .then((res) => {
          if (res.data !== null) {
            localStorage.setItem("orderItemsCount", res.data.toString());
            window.dispatchEvent(new Event("updateOrderItemCount"));
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      <div className="w-full pt-4">
        <div className="mx-auto p-2">
          <div className="flex mb-2 border-b-2 items-center justify-between flex-wrap">
            <h1 className="text-gray-900 font-bold text-4xl">
              {location.pathname.includes("parts") ? "Parts " : "Wholegoods "}{" "}
              Search
            </h1>
          </div>
          {isLoading ? (
            <Loader />
          ) : searchData.length === 0 ? (
            <div className="text-center text-lg p-5">
              Use the search to find products...
            </div>
          ) : (
            <SearchListTable data={searchData} equipmentType={2} />
          )}
        </div>
      </div>

      <EmailModal
        isOpen={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        equipment={selectedEquipment!}
        onSendSuccess={() => alert("Email sent!")}
      />
    </>
  );
}
